"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_1 = require("lodash");
const react_1 = require("react");
const __1 = require("../..");
const FormModalField_1 = require("./FormModalField");
function FormModal({ fields, isOpen = true, onSubmit, onDismiss, values, setValues, title, submitText = 'Submit', description, size = 'sm', }) {
    const ref = react_1.useRef(null);
    const fieldList = react_1.useMemo(() => {
        return lodash_1.orderBy(Object.entries(fields), field => field[1].order, 'asc');
    }, [fields]);
    const setValue = react_1.useCallback((key, value) => {
        setValues(old => (Object.assign(Object.assign({}, old), { [key]: value })));
    }, [setValues]);
    const getValue = react_1.useCallback((key) => {
        var _a;
        return (_a = values[key]) !== null && _a !== void 0 ? _a : undefined;
    }, [values]);
    return (jsx_runtime_1.jsxs(__1.Modal, Object.assign({ size: size, isOpen: isOpen, onDismiss: onDismiss, leastDestructiveRef: ref }, { children: [jsx_runtime_1.jsx(__1.ModalHeader, { children: title !== null && title !== void 0 ? title : 'Please provide the following information' }, void 0),
            jsx_runtime_1.jsx(__1.ModalBody, { children: jsx_runtime_1.jsxs(__1.Form, Object.assign({ onSubmit: onSubmit }, { children: [description, fieldList.map(([id, field], i) => {
                            return (jsx_runtime_1.jsx(FormModalField_1.FormModalField, { id: id, field: field, value: getValue(id), setValue: setValue, ref: i === 0 ? ref : undefined }, id));
                        }),
                        jsx_runtime_1.jsx(__1.Flex, { children: jsx_runtime_1.jsx(__1.Button, Object.assign({ type: "submit", variant: "primary", ml: "auto" }, { children: submitText }), void 0) }, void 0)] }), void 0) }, void 0)] }), void 0));
}
exports.FormModal = FormModal;
//# sourceMappingURL=index.js.map